var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-select',{attrs:{"value":_vm.selected,"options":_vm.orgList,"on-search":_vm.loadOrgList,"on-change":_vm.changeCallback,"placeholder":"Search for Institution..."},on:{"update:value":function($event){_vm.selected=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f98ee7a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/OrgLovComponent.vue
// module id = 802
// module chunks = 2